import { lazy } from "react";
import { connectorSettings } from "@/components/ConnectorPage";
import type { AppModule } from "../types";
import de from "./i18n/de.json";
import en from "./i18n/en.json";
import fr from "./i18n/fr.json";
import ru from "./i18n/ru.json";

const NavidromePage = lazy(() =>
  import("./NavidromePage").then((m) => ({ default: m.NavidromePage })),
);

export const navidromeModule: AppModule = {
  id: "navidrome",
  hasBackend: true,
  nav: { i18nKey: "modules.navidrome.nav", group: "media" },
  settings: connectorSettings("navidrome", true),
  routes: [{ path: "/navidrome", Component: NavidromePage }],
  i18n: { de, en, fr, ru },
};
